var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-start align-start my-2"},[_c('div',{staticClass:"indicator",style:({ backgroundColor: _vm.color })}),_c('span',{staticClass:"primary--text font-weight-bold mx-2"},[_vm._v(_vm._s(_vm.titleText))]),_c('span',{staticClass:"primary--text text-subtitle-1"},[_vm._v(_vm._s(_vm.infText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }